import styled from 'styled-components';

export const ReturnToPlayerContainer = styled.div`
    position: absolute;
    top: 30%;
    left: 0;
    z-index: 10;
`;

export const ReturnToPlayerDisplay = styled.div<{ $expanded: boolean }>`
    position: absolute;
    top: 50%;
    left: -4px;
    transform: translateY(-50%);
    background-color: rgba(17, 17, 17, 0.8);
    border-radius: 0 40px 40px 0;
    text-align: center;
    height: 60px;
    width: ${({ $expanded }) => ($expanded ? '170px' : '100px')};
    border: 2px solid #05df71;
    border-left: 0;
    cursor: pointer;
    transition: width 0.3s ease;
    overflow: hidden;
    white-space: nowrap;
    display: flex;
    align-items: center;
    justify-content: center;

    &:before,
    &:after {
        content: '';
        position: absolute;
        left: 18px;
        width: 2px;
        height: 12px;
        background-color: #05df71;
        transition: opacity 0.3s ease;
    }

    &:before {
        transform: ${({ $expanded }) =>
            $expanded ? 'rotate(45deg)' : 'rotate(-45deg)'};
        top: 35%;
    }

    &:after {
        transform: ${({ $expanded }) =>
            $expanded ? 'rotate(-45deg)' : 'rotate(45deg)'};
        top: 50%;
    }
`;

export const ReturnToPlayerText = styled.div<{ $expanded: boolean }>`
    color: #ffffff;
    font-family: 'Arial', sans-serif;
    font-size: 24px;
    font-weight: 300;
    margin-top: 4px;
    margin-left: 18px;
    display: ${({ $expanded }) => ($expanded ? 'flex' : 'block')};
    align-items: ${({ $expanded }) => ($expanded ? 'center' : 'normal')};
    justify-content: ${({ $expanded }) =>
        $expanded ? 'flex-start' : 'normal'};
    height: ${({ $expanded }) => ($expanded ? '100%' : 'auto')};
`;

export const RtpLabel = styled.span`
    color: #ffffff;
`;

export const RtpPercentage = styled.span`
    color: #05df71;
    margin-left: 10px;
`;
